// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.executiveSummary__gEUT8 {
  padding: 25px;
  background: var(--tables-main-surface);
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  column-gap: 25px;
  row-gap: 25px;
}
.executiveSummary__gEUT8::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.executiveSummary__gEUT8::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.executiveSummary__gEUT8::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.executiveSummary__gEUT8::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 850px) {
  .executiveSummary__gEUT8 {
    padding: 15px;
    row-gap: 15px;
  }
}

.printHeader__A8PzG {
  display: none;
}

@media print {
  @page {
    size: auto;
    margin: 0.5cm;
    padding: 0.5cm;
  }
  .printHeader__A8PzG {
    display: flex;
    align-items: center;
    padding-left: 15px;
    width: 100%;
    height: 80px;
    background: #2c2c2c;
  }
  .printHeader__A8PzG .logoNameIcon__U3xw2 {
    margin-left: 8px;
  }
  .executiveSummary__gEUT8 {
    padding: unset;
    overflow-y: unset;
    display: unset;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/ExecutiveSummary/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,sCAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAzEF;AAkBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAhBJ;AAmBE;EACE,+BAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,8BAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,gBAAA;EACA,kBAAA;AAnBJ;AA2DE;EAVF;IAWI,aAAA;IACA,aAAA;EAxDF;AACF;;AA2DA;EACE,aAAA;AAxDF;;AA2DA;EACE;IACE,UAAA;IACA,aAAA;IACA,cAAA;EAxDF;EA2DA;IACE,aAAA;IACA,mBAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;EAzDF;EA2DE;IACE,gBAAA;EAzDJ;EA6DA;IACE,cAAA;IACA,iBAAA;IACA,cAAA;EA3DF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.executiveSummary {\n  padding: 25px;\n  background: var(--tables-main-surface);\n  overflow-y: auto;\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 25px;\n  row-gap: 25px;\n  @include scrollBar;\n\n  @media (max-width: 850px) {\n    padding: 15px;\n    row-gap: 15px;\n  }\n}\n\n.printHeader {\n  display: none;\n}\n\n@media print {\n  @page {\n    size: auto;\n    margin: 0.5cm;\n    padding: 0.5cm;\n  }\n\n  .printHeader {\n    display: flex;\n    align-items: center;\n    padding-left: 15px;\n    width: 100%;\n    height: 80px;\n    background: #2c2c2c;\n\n    .logoNameIcon {\n      margin-left: 8px;\n    }\n  }\n\n  .executiveSummary {\n    padding: unset;\n    overflow-y: unset;\n    display: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"executiveSummary": `executiveSummary__gEUT8`,
	"printHeader": `printHeader__A8PzG`,
	"logoNameIcon": `logoNameIcon__U3xw2`
};
module.exports = ___CSS_LOADER_EXPORT___;
